import React, { createContext, useContext, useState } from "react"

const NotificationContext = createContext(null);


export const useNotificationContext = () => {
    const context = useContext(NotificationContext)
    return context
}

export const NotificationProvider = ({ children }) => {
    const [readNotification,setReadNotification] = useState(false); 
    return (
        <NotificationContext.Provider value={{ readNotification,setReadNotification }}>
            {children}
        </NotificationContext.Provider>
    )
} 